import type { SVGProps } from "react";

interface ZeekMapsIconProps extends SVGProps<SVGSVGElement> {
	className?: string;
	title?: string;
}

const ZeekMapsIcon = ({
	className,
	title = "Zeek Maps Logo",
	...props
}: ZeekMapsIconProps) => {
	return (
		<svg
			aria-label={title}
			className={className}
			viewBox="0 0 976.17 778.64"
			xmlSpace="preserve"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>{title}</title>
			<g transform="translate(-25.885 -138.38)" display="none">
				<rect
					x={-3.5714}
					y={-5.9524}
					width={1031}
					height={1031}
					display="none"
					fill="#fff"
				/>
			</g>
			<path
				d="m615.2 78.907c46.423 35.42 84.221 82.52 96.373 140.92 11.915 102.01-23.75 179.08-82.655 260.5-24.603 35.538-108.17 185.33-144.32 298.31-5.6624-18.35-75.419-194.63-130.85-287.16-48.5-77.851-110.03-177.54-95.437-263 14.69-60.573 46.792-117.28 100.81-150.98 81.331-45.831 175.42-51.302 256.08 1.4092z"
				fill="#f00"
				strokeWidth={4.9671}
			/>
			<path
				d="m548.31 147.82c29.196 17.047 55.183 35.635 70.16 73.187 11.901 33.097 5.5929 90.125-19.267 128.58-27.743 31.885-54.927 52.8-96.858 57.917-46.304 2.3654-80.185-11.6-114.53-42.375-27.895-30.532-39.697-67.932-37.893-109 7.7356-44.015 29.97-76.423 65.853-102.14 40.287-23.402 89.958-26.024 132.54-6.17z"
				fill="#800000"
				strokeWidth={4.9671}
			/>
			<path
				d="m409.19 548.27c9.4641 1.4722 9.4641 1.4722 17.456 11.147 5.4682 10.516-1.7737 18.577-1.7737 18.577-18.815 7.4631-21.955 4.1405-32.928 6.2404l-11.39 2.09c-20.371 3.9429-38.506 8.7192-57.114 18.005-5.7368 2.6191-10.256 13.12-2.1919 16.378 24.175 8.5516 47.839 13.836 73.22 17.367l12.271 1.717c82.739 10.541 167.09 5.6851 249.08-8.71l8.4783-0.57838c8.2809-2.571 16.139 15.848 6.73 26.92-11.508 7.8561-102.96 20.819-157.5 20.814-9.1763 7e-3 -18.351 0.0687-27.527 0.13225-29.664 0.0976-59.01-0.66325-88.535-3.6739l-7.6543-0.76595c-118.48-13.519-188.56-97.119 19.379-125.66z"
				display="none"
				strokeWidth={3.365}
			/>
			<path
				d="m586.91 549.74c14.82-4.8075 177.89 20.754 144.7 77.395-6.141 14.523-20.089 21.644-29.08 13.813-11.954-17.129 5.008-20.402-0.95538-31.843-58.649-35.054-116.01-25.149-124.76-32.445-5.7388-15.132 3.8998-22.361 10.095-26.92z"
				display="none"
				strokeWidth={3.365}
			/>
			<g transform="matrix(1.4761 0 0 1.4761 -145.3 -275.83)">
				<g transform="translate(13.626 -62.261)">
					<path
						d="m672.44 252.12c30.306 25.755 51.175 62.362 63 100 0.23558 0.7375 0.47115 1.475 0.71387 2.2349 18.71 59.454 10.24 125.01-18.141 179.84-6.6789 12.421-14.593 24.06-23.573 34.926-0.47969 0.58121-0.95938 1.1624-1.4536 1.7612-6.1765 7.4352-12.547 14.558-19.546 21.239-5.443-4.5406-10.503-9.3508-15.5-14.375-0.72059-0.71672-1.4412-1.4334-2.1836-2.1719-4.6435-4.6518-9.0543-9.4497-13.316-14.453 2.9044-3.4056 5.815-6.8034 8.7891-10.148 28.405-32.154 48.986-74.482 49.449-118.1 0.01-0.76746 0.0195-1.5349 0.0295-2.3256 0.23894-23.7-1.5276-45.853-9.2678-68.424-0.22414-0.66403-0.44827-1.3281-0.6792-2.0122-8.5932-25.125-22.3-47.528-40.321-66.988-1.3618-1.4722-2.7166-2.9508-4.0625-4.4375-0.56848-0.61746-1.137-1.2349-1.7227-1.8711-1.2148-1.6914-1.2148-1.6914-1.2148-4.6914 1.1548-1.5872 1.1548-1.5872 2.7891-3.3008 0.60578-0.64131 1.2116-1.2826 1.8357-1.9434 0.66008-0.68256 1.3202-1.3651 2.0002-2.0684 0.66846-0.7019 1.3369-1.4038 2.0256-2.127 6.6671-6.9684 13.483-13.789 20.349-20.561z"
						fill="#f44235"
					/>
					<path
						d="m158.06 249.13c5.443 4.5406 10.503 9.3508 15.5 14.375 0.72059 0.71672 1.4412 1.4334 2.1836 2.1719 4.6435 4.6519 9.0543 9.4497 13.316 14.453-2.9044 3.4056-5.815 6.8034-8.7891 10.148-22.784 25.79-39.093 56.013-46.211 89.852-0.16081 0.70641-0.32162 1.4128-0.4873 2.1406-5.6105 25.357-4.4202 54.732 1.4873 79.859 0.17129 0.77537 0.34257 1.5507 0.51904 2.3496 7.0563 31.37 23.591 60.323 45.481 83.65 1.3628 1.4712 2.7177 2.9498 4.0625 4.4375 0.56848 0.61746 1.137 1.2349 1.7227 1.8711 1.2148 1.6914 1.2148 1.6914 1.2148 4.6914-1.1548 1.5872-1.1548 1.5872-2.7891 3.3008-0.90867 0.96196-0.90867 0.96196-1.8357 1.9434-0.66008 0.68256-1.3202 1.3651-2.0002 2.0684-1.0027 1.0528-1.0027 1.0528-2.0256 2.127-6.6671 6.9684-13.483 13.789-20.349 20.561-39.235-33.343-62.709-83.852-71-134-0.12842-0.72316-0.25685-1.4463-0.38916-2.1914-9.8786-57.365 6.4362-120.53 39.389-167.81 3.1668-4.4703 6.5095-8.777 10-13 0.47969-0.58121 0.95939-1.1624 1.4536-1.7612 6.1765-7.4352 12.547-14.558 19.546-21.239z"
						fill="#f44335"
					/>
					<path
						d="m612.44 314.12c17.909 7.8926 30.663 35.35 37.66 52.445 4.3882 11.642 7.4252 23.263 9.3398 35.555 0.13277 0.83273 0.26555 1.6655 0.40234 2.5234 2.8411 22.184 0.0177 45.458-7.4023 66.477-0.33838 0.95979-0.33838 0.95979-0.68359 1.939-8.0004 22.176-20.588 40.554-37.316 57.061-5.9669-2.678-9.9449-7.7292-14.125-12.625-5.2662-6.1257-11.128-11.706-16.875-17.375 1.4867-3.4404 3.4669-5.6924 6.0625-8.375 19.633-21.556 27.058-48.988 26.117-77.697-1.597-26.091-13.701-49.773-32.179-67.928 1.4207-3.2456 3.1376-5.3626 5.668-7.8281 0.72896-0.71801 1.4579-1.436 2.209-2.1758 0.76248-0.74121 1.525-1.4824 2.3106-2.2461 4.9676-4.8513 9.7944-9.7254 14.298-15.015 1.4425-1.653 2.9448-3.2036 4.5144-4.7354z"
						fill="#f44235"
					/>
					<path
						d="m217.06 311.13c5.9669 2.6779 9.9449 7.7292 14.125 12.625 5.2662 6.1257 11.128 11.706 16.875 17.375-1.4867 3.4404-3.4669 5.6924-6.0625 8.375-13.409 14.722-20.951 32.291-24.938 51.625-0.19207 0.91136-0.38414 1.8227-0.58203 2.7617-3.5925 27.833 3.1467 55.806 19.918 78.383 3.6633 4.5456 7.4989 8.7633 11.664 12.855-1.4207 3.2456-3.1376 5.3626-5.668 7.8281-0.72896 0.71801-1.4579 1.436-2.209 2.1758-0.76248 0.74121-1.525 1.4824-2.3106 2.2461-4.9676 4.8513-9.7944 9.7254-14.298 15.015-1.4425 1.653-2.9448 3.2036-4.5144 4.7354-17.909-7.8926-30.663-35.35-37.66-52.445-4.3882-11.642-7.4252-23.263-9.3398-35.555-0.13277-0.83273-0.26555-1.6655-0.40234-2.5234-2.8411-22.184-0.0177-45.458 7.4023-66.477 0.22559-0.63986 0.45117-1.2797 0.68359-1.939 8.0004-22.176 20.588-40.554 37.316-57.061z"
						fill="#f44235"
					/>
				</g>
			</g>
		</svg>
	);
};

export default ZeekMapsIcon;
